import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CaretLeftIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" />
  </Icon>
)
